import { createActions, createReducer } from "reduxsauce";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

export const { Types, Creators } = createActions({
  setCategories: ["categories"],
  setSeller: ["sellerId"],
  setSubsidiary: ["subsidiary"],
  setDates: ["startDate", "endDate", "filterON"],
  setFilters: ["categories", "sellerId", "subsidiary"],
  setQuoteCategories: ["quoteCategory"],
  setStatusViveo: ["statusViveo"],
  setStatusBionexo: ["statusBionexo"],
  setOrderStatus: ["orderStatus"],
  setSelectedIndicators: ["selectedIndicators"],
  setCalendarFilter: ["calendarFilter"],
  setSentExpiredFilter: ["sentExpiredFilter"],
  setSelectedFilterCard: ["selectedFilterCard"]
});

const INITIAL_STATE: {
  productCategories: string[];
  quoteCategory: string[];
  statusViveo: string[];
  statusBionexo: string[];
  orderStatus?: string[];
  origin?: string[];
  sellerId?: string[];
  startDate?: Date;
  endDate?: Date;
  subsidiary?: string[];
  filterON?: boolean;
  selectedIndicators?: string[];
  calendarFilter?: boolean;
  sentExpiredFilter?: boolean;
  selectedFilterCard?: string;
} = {
  productCategories: [
    "100",
    "200",
    "300",
    "700",
    "1000",
    "1100",
    "1400",
    "1600",
    "2200",
    "mvm"
  ],
  filterON: false,
  quoteCategory: [],
  statusViveo: ["VALIDATE_PORTAL", "PENDING_MONEY", "ANSWERED_PORTAL"],
  statusBionexo: ["OPEN", "SENT", "UPDATED"],
  orderStatus: ["CONFIRMED", "CANCELED"],
  selectedIndicators: [],
  calendarFilter: false,
  sentExpiredFilter: false,
  selectedFilterCard: ""
};

const setCategories = (state = INITIAL_STATE, action: any) => ({
  ...state,
  productCategories: action.categories,
});

const setQuoteCategories = (state = INITIAL_STATE, action: any) => ({
  ...state,
  quoteCategory: action.quoteCategory,
});

const setStatusBionexo = (state = INITIAL_STATE, action: any) => ({
  ...state,
  statusBionexo: action.statusBionexo,
});

const setStatusViveo = (state = INITIAL_STATE, action: any) => ({
  ...state,
  statusViveo: action.statusViveo,
});

const setOrderStatus = (state = INITIAL_STATE, action: any) => ({
  ...state,
  orderStatus: action.orderStatus,
});

const setSeller = (state = INITIAL_STATE, action: any) => ({
  ...state,
  sellerId: action.sellerId,
});

const setSubsidiary = (state = INITIAL_STATE, action: any) => {
  return { ...state, subsidiary: action.subsidiary };
};

const setFilters = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    subsidiary: action.subsidiary,
    sellerId: action.sellerId,
    productCategories: action.productCategories,
    origin: action.origin,
  };
};

const setDates = (state = INITIAL_STATE, action: any) => ({
  ...state,
  startDate: action.startDate,
  endDate: action.endDate,
  filterON: action.filterON,
});

const setSelectedIndicators = (state = INITIAL_STATE, action: any) => ({
  ...state,
  selectedIndicators: action.selectedIndicators,
});

const setCalendarFilter = (state = INITIAL_STATE, action: any) => ({
  ...state,
  calendarFilter: action.calendarFilter,
});

const setSentExpiredFilter = (state = INITIAL_STATE, action: any) => ({
  ...state,
  sentExpiredFilter: action.sentExpiredFilter,
});

const setSelectedFilterCard = (state = INITIAL_STATE, action: any) => ({
  ...state,
  selectedFilterCard: action.selectedFilterCard,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_CATEGORIES as any]: setCategories,
  [Types.SET_QUOTE_CATEGORIES as any]: setQuoteCategories,
  [Types.SET_STATUS_BIONEXO as any]: setStatusBionexo,
  [Types.SET_STATUS_VIVEO as any]: setStatusViveo,
  [Types.SET_ORDER_STATUS as any]: setOrderStatus,
  [Types.SET_SELLER as any]: setSeller,
  [Types.SET_SUBSIDIARY as any]: setSubsidiary,
  [Types.SET_DATES as any]: setDates,
  [Types.SET_FILTERS as any]: setFilters,
  [Types.SET_SELECTED_INDICATORS as any]: setSelectedIndicators,
  [Types.SET_CALENDAR_FILTER as any]: setCalendarFilter,
  [Types.SET_SENT_EXPIRED_FILTER as any]: setSentExpiredFilter,
  [Types.SET_SELECTED_FILTER_CARD as any]: setSelectedFilterCard
});
